export const categoryInfos = [
  {
    title: "Electronics",
    name: "electronics",
    imgLink: "https://m.media-amazon.com/images/I/51FHPa9m1cL._SL1000_.jpg",
  },
  {
    title: "Discover Fashion Trends",
    name: "women's clothing",
    imgLink: "https://m.media-amazon.com/images/I/51PUcjEMgvL._AC_SX569_.jpg",
  },
  {
    title: "Men's Clothing",
    name: "men's clothing",
    imgLink: "https://m.media-amazon.com/images/I/81eg0LnoPNL._AC_SX569_.jpg",
  },
  {
    title: "Jewelry",
    name: "jewelery",
    imgLink: "https://m.media-amazon.com/images/I/81PxbASxq1L._AC_SY695_.jpg",
  },
];
